import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a1kpo4g3o4: FaireBrandEntity = {
  token: "b_a1kpo4g3o4",
  type: "brand",
  name: "Fawn & Foster",
  avatarUrl:
    "https://cdn.faire.com/fastly/44b40802a10ca8e8c6fff6dae6fb5f7ce15be35f5c9b40148e14d49f99b58806.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8efb40859125e15d891ea5e68d19d5fce6604e829d45c27e2e6d4860dc2990e3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/44b40802a10ca8e8c6fff6dae6fb5f7ce15be35f5c9b40148e14d49f99b58806.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8efb40859125e15d891ea5e68d19d5fce6604e829d45c27e2e6d4860dc2990e3.jpeg",
  location: "Minneapolis, MN, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 24,
  isInsider: true,
  description:
    "Organic, heirloom quality baby essentials. Invest in good - portion of proceeds donated to foster care + children in-need ❤\n\nDesigned by us in the USA, we hand-pick the finest organic materials, keeping in mind baby's delicate skin, to create baby essentials that every mom loves. Each product comes in beautiful, minimal packaging stating our mission, making for the perfect gift. \n\nOur backstory: Fawn & Foster's founder Rachel, after bringing her foster babies home with nothing but a diaper to their name, knew she could do more to help the hundreds of thousands of children in foster care in the US. She paired her love for children with the creation of this baby brand, with the sole purpose of donating back to directly helping foster children.\n\nOur woman owned business is now in the hands of Kendra & Shantel. Two moms, long time lovers of Fawn & Foster, still on a mission to give back to children in need. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:12.355Z",
    importedBy: "entity-db-cli",
  },
};
